import { escapeHtml } from './utils.js';

export function linkifyEmailHtml(html) {
  const template = document.createElement('template');
  template.innerHTML = String(html || '');
  const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) if (!walker.currentNode.parentElement?.closest('a, script, style, button')) nodes.push(walker.currentNode);
  for (const node of nodes) {
    const text = node.textContent;
    const matches = [...text.matchAll(/https?:\/\/[^\s<>"']+/gi)];
    if (!matches.length) continue;
    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const match of matches) {
      let value = match[0].replace(/[.,;!?]+$/, '');
      while (value.endsWith(')') && (value.match(/\)/g)?.length || 0) > (value.match(/\(/g)?.length || 0)) value = value.slice(0, -1);
      try { if (!['http:', 'https:'].includes(new URL(value).protocol)) continue; } catch { continue; }
      fragment.append(document.createTextNode(text.slice(offset, match.index)));
      const link = document.createElement('a');
      link.href = value; link.textContent = value; link.target = '_blank'; link.rel = 'noopener noreferrer';
      fragment.append(link); offset = match.index + value.length;
    }
    fragment.append(document.createTextNode(text.slice(offset)));
    node.replaceWith(fragment);
  }
  for (const link of template.content.querySelectorAll('a[href]')) { link.target = '_blank'; link.rel = 'noopener noreferrer'; }
  return template.innerHTML;
}

export function emailBodyHtml(html = '', text = '', translatedText = null) {
  const original = String(html || '').replace(/src="cid:boi-([a-f0-9]{24})"/gi, (_match, id) => `src="/api/v1/attachments/${id}?inline=1"`);
  if (translatedText === null) return original || escapeHtml(text).replace(/\n/g, '<br>');
  const media = [...original.matchAll(/<img\b[^>]*>|<button\b[^>]*class="remote-image-placeholder"[^>]*>[^<]*<\/button>|<span\b[^>]*class="missing-inline-image"[^>]*>[^<]*<\/span>/gi)].map((match) => match[0]).join('');
  return `<p>${escapeHtml(translatedText).replace(/\n/g, '<br>')}</p>${media ? `<div class="translated-email-media" aria-label="Immagini del messaggio originale">${media}</div>` : ''}`;
}

export function emailAttachmentList(attachments = []) {
  if (!attachments.length) return '';
  return `<div class="email-attachment-list"><strong>Allegati (${attachments.length})</strong><div>${attachments.map((file) => `<a href="/api/v1/attachments/${escapeHtml(String(file.id || file._id))}" download aria-label="Scarica ${escapeHtml(file.filename || 'allegato')}">📎 ${escapeHtml(file.filename || 'Allegato')} <small>${Math.max(1, Math.ceil(Number(file.size || 0) / 1024))} KB${file.disposition === 'inline' ? ' · immagine inline' : ''}</small></a>`).join('')}</div></div>`;
}

export function loadRemoteEmailImage(target) {
  const button = target?.closest?.('.remote-image-placeholder[data-remote-src]');
  if (!button) return false;
  let url;
  try { url = new URL(button.dataset.remoteSrc, window.location.href); }
  catch { button.replaceWith(document.createTextNode('[Immagine remota non disponibile]')); return true; }
  if (url.protocol !== 'https:') return true;
  const image = document.createElement('img');
  image.setAttribute('data-live-preserve', '');
  image.src = url.href;
  image.alt = button.dataset.imageAlt || 'Immagine remota';
  image.addEventListener('error', () => { image.replaceWith(document.createTextNode('[Immagine remota non disponibile]')); }, { once: true });
  button.replaceWith(image);
  return true;
}
